const breakpointsObject: any = {
  s: '784px',
  m: '1024px',
  l: '1192px',
  xl: '1280px',
};

const maxWidths = breakpointsObject;
const breakpoints: any = Object.values(breakpointsObject);

breakpoints.s = maxWidths.s;
breakpoints.m = maxWidths.m;
breakpoints.l = maxWidths.l;
breakpoints.xl = maxWidths.xl;

export { breakpoints, breakpointsObject, maxWidths };
